import { useEffect } from "react";
import Seo from "@/components/Seo";
import HeroSection from "@/components/home/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import ProblemSection from "@/components/home/ProblemSection";
import GapSection from "@/components/home/GapSection";
import ServiceModelSection from "@/components/home/ServiceModelSection";
import ExperienceSection from "@/components/home/ExperienceSection";
import FollowTheErrorSection from "@/components/home/FollowTheErrorSection";
import CtaBand from "@/components/CtaBand";
import ComparePill from "@/components/ComparePill";

export default function HomePage() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex, nofollow");
    meta.setAttribute("data-stylea", "");
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <>
      <Seo
        title="Improve Systems — Product & Transformation Advisory"
        siteName="Improve Systems"
        description="Improve Systems helps organizations understand what needs to change before they invest in changing it — product discovery, requirements and workflow design, rapid prototyping, vendor evaluation, and implementation governance."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Improve Systems",
          description:
            "Product and transformation advisory: product discovery, requirements and workflow analysis, rapid prototyping, vendor and solution evaluation, and implementation governance for organizations improving or replacing complex systems.",
          slogan: "Understand. Improve. Monitor.",
        }}
      />
      <HeroSection />
      <EditorialMarquee />
      <ProblemSection />
      <GapSection />
      <ServiceModelSection />
      <ExperienceSection />
      <FollowTheErrorSection />
      <CtaBand />
      <ComparePill to="/" label="VIEW STYLE B — AVID" />
    </>
  );
}
